import { useEffect, useState } from "react";

import { getSasTokenForTile } from "../services/svt/svt-user";

const useGetSasTokenForTile = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchSasToken = async () => {
            try {
                setLoading(true);
                const token = await getSasTokenForTile();
                setData(token?.data);
            } catch (error) {
                setData("");
            } finally {
                setLoading(false);
            }
        };
        fetchSasToken();
    }, []);

    return [data, loading];
};

export default useGetSasTokenForTile;
